import { memo, useCallback } from "react";

import { Dialog, DialogContent } from "@/components/ui/dialog";

import { GlobalSearchContent } from "./GlobalSearchContent";
import type { IGlobalSearchProps } from "./types";

// NOTE: NSAI-6589 — the global search palette (Cmd/Ctrl+K or the header search
// button). It grew out of the SearchChats dialog and keeps its chat sections.
// The cmdk root lives in GlobalSearchContent, which owns the highlight
// (NSAI-6762) and is unmounted while the dialog is closed.
const GlobalSearchComponent = ({
  isOpen,
  onOpenChange,
}: IGlobalSearchProps): JSX.Element => {
  const handleClose = useCallback((): void => {
    onOpenChange(false);
  }, [onOpenChange]);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        hideCloseButton
        className="overflow-hidden p-0 shadow-lg max-w-2xl"
      >
        <GlobalSearchContent onClose={handleClose} />
      </DialogContent>
    </Dialog>
  );
};

export const GlobalSearch = memo(GlobalSearchComponent);
